import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Button, Modal as ReactstrapModal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class DescriptionModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            description: '',
        };
    }

    static propTypes = {
        isShowDescriptionModal: PropTypes.bool,
        toggleDescriptionModal: PropTypes.func,
        onUpdate: PropTypes.func.isRequired,
        description: PropTypes.string,
    };

    static defaultProps = {
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({description: nextProps.description});
    }

    handleInputChange(e) {
        this.setState({description: e.target.value});
    }
    
    render() {
        const {description} = this.state;
        const {isShowDescriptionModal} = this.props;

        return (
            <ReactstrapModal isOpen={isShowDescriptionModal} toggle={() => this.props.toggleDescriptionModal()} className="status-note-modal">
                <ModalHeader toggle={() => this.props.toggleDescriptionModal()}>Modify description</ModalHeader>
                <ModalBody>
                    <label>
                        <p>Description: </p>
                        <textarea
                            className="form-control"
                            value={description}
                            onChange={(e) => this.handleInputChange(e)}
                        />
                    </label>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => this.props.onUpdate(description)}>Save</Button>
                    <Button color="secondary" onClick={() => this.props.toggleDescriptionModal()}>Cancel</Button>
                </ModalFooter>
            </ReactstrapModal>
        );
    }
}

export default DescriptionModal;



// WEBPACK FOOTER //
// ./src/components/CommonModals/DescriptionModal.js